export enum ModalStatusLoadingEnums {
	INACTIVE = 'inactive',
	ACTIVE = 'active',
	FAILED = 'failed',
	SUCCESS = 'success'
}
